import userClient from "../config/api/userClient";
var announcementUrl = "announcements";
export var getAnnouncementLatest = function (params) {
    return userClient.get(announcementUrl + "/latest", { params: params });
};
